import logo from '../../assets/images/ascasSVG.svg';
import './figmaheader.scss';
const FigmaHeader = ({editedDate}) => {
  let date = new Date();
  let todayDate = editedDate ? editedDate : `${date.getDate()}-${date.getMonth() + 1}-${date.getFullYear()}`;
  return (
    <div className='mainFigmaHeader'>
      <div className='HeaderContainer'>
        <div className='imgContainer1'>
          <img src={logo} alt='' />
        </div>
        <div>
          <div className='locationContainer'>
            <p>ASCAS Fertility and Women's Centre</p>
          
          </div>
        
        </div>
      </div>
      <div style={{textAlign: 'right'}}>
        <section>
          <label style={{fontSize: '14px', fontWeight: '600'}}>Date :</label>
          <span> {todayDate}</span>
        </section>
      </div>
    </div>
  );
};

export default FigmaHeader;
